var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbar3"},[_vm._v("还没开发呢！！！！")])}
var staticRenderFns = []

export { render, staticRenderFns }